//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
export default{
	data(){
		return{
			query:{},
			dialogVisible:false,
			isCoupon:false,
			title:"",
			messages:"",
			versionMessages:""
		}
	},
	props:{
		schema:{
			type:Object
		},
		status:{
			type:Number
		}
	},
	computed:{
		topImgUrl(){
			return this.$store.state.promotion.topImgUrl
		},
		topImgUrlHref(){
			return this.$store.state.promotion.topImgUrlHref
		},
		listData(){
			return this.$store.state.promotion.listData
		},
		listButtonText(){
			return this.$store.state.promotion.listButtonText
		},
		buttomImgUrl(){
			return this.$store.state.promotion.buttomImgUrl
		},
		bottomImgHref(){
			return this.$store.state.promotion.bottomImgHref;
		},
		buttonData(){
			return this.$store.state.promotion.buttonData
		},
		isTop(){
			return this.$store.state.promotion.isTop
		},
		isList(){
			return this.$store.state.promotion.isList
		},
		listType(){
			return this.$store.state.promotion.listType
		},
		isButton(){
			return this.$store.state.promotion.isButton
		},
		isBottom(){
			return this.$store.state.promotion.isBottom
		},
		projectType(){
			return this.$store.state.promotion.projectType
		},
		buttonProjectType(){
			return this.$store.state.promotion.buttonProjectType
		},
		versions(){
			var u = navigator.userAgent
            var app = navigator.appVersion
            return {         //移动终端浏览器版本信息
              trident: u.indexOf('Trident') > -1, //IE内核
              presto: u.indexOf('Presto') > -1, //opera内核
              webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
              gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
              mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
              ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
              android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
              iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
              iPad: u.indexOf('iPad') > -1, //是否iPad
              webApp: u.indexOf('Safari') == -1//是否web应该程序，没有头部与底部
            }
		},
		appVersion(){
			if(this.query.appVersion!== undefined){
				return parseInt(this.query.appVersion.replace(/\./g, ""));
			}
			return 0;
		},
		isLowVersion(){
			return (this.versions.ios && this.appVersion > 1000) || (this.versions.android && this.appVersion > 1000)
		},
        buttonClass() {
		    return {
                'buttonOne': this.buttonData.type == 1 ? 'buttonOne':'',
                'isNone': !this.isButton
            }
        }
	},
	watch:{
		schema(){
			if(this.schema !== undefined){
				this.$store.dispatch("promotion/set_state",this.schema);
			}
		}
	},
	methods:{
		getButtonText(){
			let text = "";
			if(this.buttonProjectType == 2){
				return this.buttonData.receive;
			}
			if(this.buttonProjectType == 3 && sessionStorage[this.$store.state.route.query.uuid]){
				return this.buttonData.received;
			}
			return this.buttonData.isAct ? this.buttonData.received : this.buttonData.receive;
		},
		getListButtonText(list){
			let text = "";
			if(this.projectType == 2){
				return this.listButtonText.receive;
			}
			return list.isAct ? this.listButtonText.received : this.listButtonText.receive;
		},
		getActivity(list,type,event){
			if(type == 1){
				this.checkJoinActivity(list);
			}else if(type == 2){
				this.goToGoods(list.goods.goodsCode);
			}else if(type == 3){
				sessionStorage[this.$store.state.route.query.uuid] = true;
				this.ImgUrlHrefFn(list.goodsHref,event);
			}
		},
		goToGoods(id){
			this.jumpToGoods(id);
		},
		jumpToGoods(id){
			window.dsBridge.call('showProductDetail',id);
		},
		delayVersionlow(){
			let that = this;
			setTimeout(function(){
				that.versionlow(that);
			},1000)
		},
		versionlow(that){
			that.dialogVisible = true;
			that.versionMessages = that.$t("versionLowPlaceholder");
		},
		showCoupon(event){
			let data = this.joinData;
			window.dsBridge.call('showCoupon',data);
		},
		/*checkJoinActivity(list){
			if(this.query.loginCustomerId){
				this.joinActivity(list.act_code,()=>{
					list.isAct = true;
					this.dialogVisible = true;
				})
			}else{
				//App登录或注册,
				//同步调用
				let logon= dsBridge.call("jumpToNativePage",'startRegister');
				debugger;
				if(!logon){
					//this.messages = '123';
              		this.dialogVisible = true;
				}

			}
		},*/
		checkLogin(){
			try{
				if(!Object.keys(this.getLoginMsg).length){
					this.delayVersionlow();			
				}
			}catch(e){
			}
		},
		checkJoinActivity(list){
			this.checkLogin();
			this.joinActivity(list.act_code,()=>{
				list.isAct = true;
				this.dialogVisible = true;
			})
		},
		joinActivity(act_code,callback){
			let that = this;
			let params = {
				act_code:act_code,
				lang:this.query.lang,
				streamNo:'web_saas' + (new Date()).getTime() + parseInt(Math.random() * 1000000),
				access_token:this.query.access_token,
				loginCustomerId:this.query.loginCustomerId
			}
			axios({
              method:"get",
              url: "/webmps/marketing/banner/joinActivity",
              headers:{'Accept-Language':this.query.lang},
              params:params
            }).then(res => {
              if(res.data.resultCode == '00000000'){
              	callback();
              	this.messages = "success";
              	this.joinData = JSON.stringify(res.data.data);
              	if(this.query.appVersion !== undefined){
              		this.isCoupon = true;
              	}else{
              		this.versionMessages = this.$t("versionLowPlaceholder");
              	}
              }else{
              	this.messages = res.data.resultDesc
              	this.dialogVisible = true;
              }
            }).catch(err => {
            	this.title = "error";
            	this.messages = err.message;
            	this.dialogVisible = true;
            })
		},
		ImgUrlHrefFn(hrefLink,event){
			if(hrefLink){
				if(event && hrefLink.indexOf(',') >= 0 ){
					let newValArray = hrefLink.split(',');
					window.dsBridge.call(newValArray[0],newValArray[1]);
				}else if (/\/\//g.test(hrefLink) && !event){
					return hrefLink;
				}else if (/\/\//g.test(hrefLink) && event == "3"){
					return hrefLink;
				}else if  (/\/\//g.test(hrefLink) && typeof(event) == "boolean"){
					location.href= hrefLink;
				}else if  (/\/\//g.test(hrefLink)){
					return hrefLink;
				}
			}
		}
	},
	created(){
		let getLoginMsg = window.dsBridge.call('getLoginMsg');
		this.getLoginMsg = getLoginMsg ? JSON.parse(getLoginMsg) : {};
		this.query = this.$route.query;
		if(!this.query.access_token){
			this.query.access_token = this.getLoginMsg.access_token;
			this.query.loginCustomerId = this.getLoginMsg.loginCustomerId;
		}
		if(this.schema !== undefined){
			this.$store.dispatch("promotion/set_state",this.schema);
		}
	}

}



// WEBPACK FOOTER //
// ./src/views/popUpPreview.vue